export default class EventImpression {
    constructor($element) {
        const url = $element.dataset.eventImpressionUrl;

        if (!url || $element.dataset.eventImpressionSent) {
            return;
        }

        $element.dataset.eventImpressionSent = 'true';

        fetch(url, {
            method: 'POST',
            cache: 'no-store',
            credentials: 'omit',
            keepalive: true,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).catch(() => {});
    }
}
